export enum TriggerType {
  PURCHASE = "PURCHASE",
  SALES = "SALES",
  MATERIAL_RECEIPT = "MATERIAL_RECEIPT",
}
